/* eslint-disable no-undef */

import ServicesSlider from './services_slider';

document.addEventListener('DOMContentLoaded', function() {

  var is_mobile = window.innerWidth < 1024;

  addEventListener('resize', (event) => {
    is_mobile = window.innerWidth < 1024;
  });

  let splashscreen = document.querySelector('.splashscreen');

  if(splashscreen != null) {

    let logo = document.querySelector('.logo');
    logo.style.mixBlendMode = 'unset';

    let logoTrig = ScrollTrigger.create({
      trigger: '.top-banner',
      start: 'top top',
      end: 'bottom top',
      onEnter: function() {
        logo.style.mixBlendMode = 'unset';
      },
      onEnterBack: function() {
        logo.style.mixBlendMode = 'unset';
      },
      onLeave: function() {
        logo.style.mixBlendMode = 'difference';
      },
    });


    if(window.screen.width > 768) {

      if(getCookie('displayed_once') != 1) {

        opening_animation(splashscreen);
        document.cookie = 'displayed_once=1';
      } else {
        cancel_opening_animation(splashscreen);
      }

      fade_title();
    } else {
      cancel_opening_animation(splashscreen);

      let title = document.querySelector('.splashscreen__txt');

      gsap.set(title,
      {
        opacity: 0,
      });

      document.querySelector('.top-banner2__real-title').classList.add('top-banner2__real-title--bg');
    }
  }


  if(document.querySelector('.subpage-banner') != null) {
    let image = document.querySelector('.subpage-banner__wrap');

    gsap.fromTo(image,
      {
        scale: 0.3,
      },
      {
        scale: 1,
        scrollTrigger: {
          trigger: image,
          start: 'top bottom',
          end: 'bottom center',
          invalidateOnRefresh: true,
          once: false,
          scrub: 3,
          toggleActions: 'play none reverse reverse',
        },
      }
    );
  }

  if(document.querySelector('#mask') != null) {

    let main_bnr = new Vivus('mask', {//アニメーションをするIDの指定
      start:'manual',//自動再生をせずスタートをマニュアルに
      type: 'scenario',// アニメーションのタイプを設定
      duration: 150,//アニメーションの時間設定。数字が小さくなるほど速い
      forceRender: false,//パスが更新された場合に再レンダリングさせない
      animTimingFunction:Vivus.EASE,//動きの加速減速設定
    }, function(){
      document.querySelector('.st0').classList.add('st0--after');
    });

    main_bnr.play();

  }
  

  let hamburger = document.querySelector('[data-toggle-menu]');
  
  hamburger.addEventListener('click', function(e) {
    toggle_menu();
  });

  function toggle_menu(){
    let menu = document.querySelector('.navigation');
    menu.classList.toggle('navigation--open');

    let hamburger = document.querySelector('[data-toggle-menu]');
    hamburger.classList.toggle('top-btn--open');
    toggle_lock_page();
  }

  let menu_links =  document.querySelectorAll('.navigation__sub-link');
  menu_links.forEach(function(menu_link) {
    menu_link.addEventListener('click', function(e) {
      toggle_menu();
    });
  });


  document.querySelectorAll('[data-nav-toggle]').forEach(function(toggle_nav_btn) {
    toggle_nav_btn.addEventListener('click', function(e) {
      e.preventDefault();
  
      let is_open = this.classList.contains('open');

      let nav_id = this.dataset.navToggle;
      let selector = '[data-nav-id="'+nav_id+'"]';

      close_nav();

      if(!is_open) {
        document.querySelectorAll(selector).forEach(function(elem) {
          elem.classList.add('open');
          
          // if(!is_mobile) {
          //   let sub_links = elem.querySelectorAll('.navigation__sub-link');

          //   gsap.fromTo(sub_links, 
          //   {
          //     opacity: 0,
          //     x: -30,
          //   },
          //   {
          //     x: 0,
          //     opacity: 1,
          //     stagger: 0.1,
          //     duration: 0.3,
          //     delay: 0.5,
          //     ease: Power1.easeOut,
          //     clearProps: 'all',
          //   });
          // }

        });
  
        this.classList.add('open');
      }
    });
  });


  let services_slider_node = document.querySelector('[data-services-slider]')
  if(services_slider_node != null) {
    let service_slider = new ServicesSlider({
      node: services_slider_node,
    });
  }


  let faq_questions = document.querySelectorAll('[data-toggle-faq]');
  faq_questions.forEach(function(faq_question) {

    faq_question.addEventListener('click', function(e) {
      let height = 0;
      let faq = faq_question.parentNode;
      let answer = faq.querySelector('.faq__answer');

      $(answer).slideToggle();
      
      faq.classList.toggle('faq--open');
    });
  })

  //on load close all slide toggle
  $('.faq__answer').slideToggle();


  let accordion_buttons = document.querySelectorAll('[data-toggle-accordion]');
  accordion_buttons.forEach(function(accordion_button) {

    accordion_button.addEventListener('click', function(e) {
      let height = 0;
      let accordion = accordion_button.parentNode;
      let content = accordion.querySelector('.accordion__content');

      $(content).slideToggle();
      
      accordion.classList.toggle('accordion--open');
    });
  })

  //on load close all slide toggle
  $('.accordion__content').slideToggle();



  function close_nav() {
    document.querySelectorAll('[data-nav-id]').forEach(function(elem) {
      elem.classList.remove('open');
    });

    document.querySelectorAll('.navigation__link-wrap--has-link').forEach(function(elem) {
      elem.classList.remove('open');
    });
  }

  function toggle_lock_page() {
    document.querySelector('body').classList.toggle('container-scroll--lock');
  }


  function opening_animation(splashscreen) {
    let svg = splashscreen.querySelector('svg');
    let skew = splashscreen.querySelector('.splashscreen__skew');
    let bg = splashscreen.querySelector('.splashscreen__bg');

    let wrap = document.querySelector('.splashscreen__txt-wrap');

    let title = document.querySelector('.splashscreen__txt');
    let cover = document.querySelector('.splashscreen__txt-cover');

    let news = document.querySelector('.top-banner__news');

    let video = document.querySelector('.top-banner__video');
    video.pause();


    let splash_timeline = gsap.timeline();

    splash_timeline.to(svg,
    {
      color: '#33d1cb',
      duration: 0.8,
    });

    splash_timeline.to(skew,
    {
      left: '0',
      duration: 0.8,
    });

    splash_timeline.fromTo(cover,
    {
      right: '100%',
    },
    {
      right: 0,
      duration: 0.8,
    });

    splash_timeline.fromTo(bg,
    {
      opacity: 1,
    },
    {
      opacity: 0,
      duration: 0.5,
    }, '<');

    splash_timeline.fromTo(svg,
    {
      opacity: 1,
    },
    {
      opacity: 0,
      duration: 0.5,
    }, '<');

    splash_timeline.fromTo(title,
    {
      opacity: 0,
    },
    {
      opacity: 1,
      duration: 0.1,
    });

    splash_timeline.fromTo(title,
    {
      yPercent: 100,
    },
    {
      yPercent: 0,
      duration: 0.5,
      onComplete: function(){
        video.play();
      },
    });

    splash_timeline.fromTo(cover,
    {
      left: 0,
    },
    {
      left: '100%',
      duration: 0.5,
    });


    splash_timeline.to(skew,
    {
      left: '200%',
      duration: 1,
    });

    splash_timeline.to(wrap,
    {
      zIndex: 50,
      duration: 0.1,
    });

    splash_timeline.fromTo(news,
    {
      opacity: 0,
    },
    {
      opacity: 1,
      duration: 0.5,
    });
  }

  function cancel_opening_animation(splashscreen) {
    let svg = splashscreen.querySelector('svg');
    let skew = splashscreen.querySelector('.splashscreen__skew');
    let bg = splashscreen.querySelector('.splashscreen__bg');

    let wrap = document.querySelector('.splashscreen__txt-wrap');

    let title = document.querySelector('.splashscreen__txt');
    let cover = document.querySelector('.splashscreen__txt-cover');

    let news = document.querySelector('.top-banner__news');

    gsap.set(bg,
    {
      opacity: 0,
    });

    gsap.set(title,
    {
      opacity: 1,
      yPercent: 0,
    });

    gsap.set(svg,
    {
      opacity: 0,
    });

    gsap.set(wrap,
    {
      zIndex: 50,
    });

    gsap.set(news,
    {
      opacity: 1,
    });

    gsap.set(cover,
    {
      left: '100%',
      right: 0,
    });
  }

  function fade_title() {
    let title = document.querySelector('.splashscreen__txt');

    gsap.set('.top-banner2__real-title',
    {
      opacity: 0,
    });

    gsap.set('.top-banner2__title',
    {
      opacity: 0,
      y: 80,
    });

    gsap.set('.top-banner2__txt',
    {
      opacity: 0,
      y: 80,
    });

    gsap.set('.top-banner2__button',
    {
      opacity: 0,
      y: 80,
    });

    let scrollTrig = ScrollTrigger.create({
      trigger: '.top-banner2__real-title',
      start: 'center center',
      endTrigger: '.top-banner2__real-title',
      end: 'center center',
    });

    let banner2_timeline = gsap.timeline({
      scrollTrigger: scrollTrig,
    });
    

    banner2_timeline.to(title,
    {
      opacity: 0,
      duration: 0.1,
    });


    banner2_timeline.to('.top-banner2__real-title',
    {
      opacity: 1,
      duration: 0.1,
      onComplete: function(){
        document.querySelector('.top-banner2__real-title').classList.add('top-banner2__real-title--bg');
        //top_banner2_anim();
      },
    }, '<');

    banner2_timeline.to('.top-banner2__title',
    {
      y: 0,
      opacity: 1,
      duration: 0.5,
    },'+=0.5');

    banner2_timeline.to('.top-banner2__txt',
    {
      y: 0,
      opacity: 1,
      duration: 0.5,
    });

    banner2_timeline.to('.top-banner2__button',
    {
      y: 0,
      opacity: 1,
      duration: 0.5,
    });
  }


  let fade_up_items = document.querySelectorAll('[data-fade-up]');

  fade_up_items.forEach(function(fade_up_item) {
    let fade_delay = fade_up_item.dataset.fadeDelay;
    let duration = 0.5;

    gsap.fromTo(fade_up_item, 
    {
      opacity: 0,
      y: 50,
    },
    {
      scrollTrigger: {
        trigger: fade_up_item,
        start: 'top 90%',
      }, // start the animation when ".box" enters the viewport (once)
      y: 0,
      opacity: 1,
      delay: fade_delay,
      duration: duration,
      ease: Power1.easeOut,
      clearProps: 'all',
    });
  });


  let cascade_triggers = document.querySelectorAll('[data-fade-up-cascade-trigger]');

  cascade_triggers.forEach(function(cascade_trigger) {
    let fade_delay = cascade_trigger.dataset.fadeDelay;
    let duration = 0.5;

    let fade_items = cascade_trigger.querySelectorAll('[data-fade-up-cascade]');

    gsap.fromTo(fade_items, 
    {
      opacity: 0,
      y: 50,
    },
    {
      scrollTrigger: {
        trigger: cascade_trigger,
        start: 'top 90%',
      }, // start the animation when ".box" enters the viewport (once)
      y: 0,
      opacity: 1,
      stagger: fade_delay,
      duration: duration,
      ease: Power1.easeOut,
      clearProps: 'all',
    });

  });


  let accordion_row_button = document.querySelector('[data-toggle-accordion-row]');
  if(accordion_row_button != null) {
    accordion_row_button.addEventListener('click', function(e) {
      let accordion_row = document.querySelector('.table__accordion-row');
      accordion_row.classList.toggle('table__accordion-row--open');
  

      accordion_row_button.querySelector('.table__button').classList.toggle('table__button--open');
    });
  }
  
  
  function getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }


  let archive_select =  document.querySelector('[data-archive-select]');
  if(archive_select != null) {
    archive_select.addEventListener('input', function (event) {

      if (event.target.value !== '') {
        window.location.href = event.target.value;
      }
    }, false);
  }


  //if contact page 
  if(document.querySelector('.wpcf7') != null) {
    const queryString = window.location.search;
    //console.log(queryString);

    const urlParams = new URLSearchParams(queryString);
    const service = urlParams.get('service');

    if(service != null) {
      let position_wrap = document.querySelector('[data-name="position"]');
  
      let input_radios = position_wrap.querySelectorAll('input');

      let service_index = service - 1;

      if(service_index in input_radios) {
        input_radios[service_index].checked = true;
        //console.log(input_radios[service_index]);
      }
      
    }

    

    //service.toInt
  }
});

$(function(){

  // $('a[href^="#"]').click(function () {
  //   const speed = 600;
  //   let href = $(this).attr('href');
  //   let target = $(href == '#' || href == '' ? 'html' : href);
  //   let position = target.offset().top;
  //   $('body,html').animate({ scrollTop: position }, speed, 'swing');
  //   return false;
  // });



	//現在のページURLのハッシュ部分を取得
	const hash = location.hash;

	//ハッシュ部分がある場合の条件分岐
	if(hash){
		//ページ遷移後のスクロール位置指定
		$('html, body').stop().scrollTop(0);
		//処理を遅らせる
		setTimeout(function(){
			//リンク先を取得
			const target = $(hash),
			//リンク先までの距離を取得
			position = target.offset().top;
			//指定の場所までスムーススクロール
			$('html, body').animate({scrollTop:position}, 500, 'swing');
		});
	}



  let submitBtn = $('.wpcf7-submit'); // 送信ボタン
  submitBtn.click(function () { // 送信ボタンが押されてら
    $(this).css({
      pointerEvents: 'none', // ボタンを触れなくする
      opacity: '0.5', // 半調にする
    });
  });
  document.addEventListener('wpcf7invalid', function () {
    // wpcf7invalid → 正しくない入力があったためにメール送信は行われなかった場合に発生する。
    submitBtn.css({
      pointerEvents: 'auto', // ボタン復活
      opacity: '1', // 透明度を100%にする
    });
  }, false);


});


// WEBPACK FOOTER //
// ./scripts/main.js